<template>
    <div>
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>

        <div class="container">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="订单编号:">
                    <el-input v-model="queryParams.ordersn" placeholder="请输入订单编号" clearable></el-input>
                </el-form-item>
              <el-form-item label="用户id:" >
                <el-input v-model="queryParams.uid" placeholder="请输入用户id" clearable></el-input>
              </el-form-item>
                <el-form-item label="订单起止时间:" prop="time">
                    <el-date-picker ref="drawDate" style="margin-left: 5px;" v-model="queryParams.time" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable @change="changeQuery">
                    </el-date-picker>
                </el-form-item>
                <div style="float: right">
                    <el-button type="primary" @click="changeQuery()">搜索</el-button>
                </div>
            </el-form>

<!--            <div class="action">
                <el-button type="primary" @click="exportFile">导出</el-button>
            </div>-->
            <!-- 表格内容 -->
            <el-table v-loading="loading" :data="pageInfo.list" element-loading-text="数据加载中" stripe border ref="multipleTable" style="margin-top:20px">
                <el-table-column prop="id" label="id" width="80" align="center"></el-table-column>
                <el-table-column prop="local_uid" label="用户id" width="80" align="center"></el-table-column>
                <el-table-column prop="local_order_no" label="订单编号" width="200" align="center"></el-table-column>
                <el-table-column prop="payment_no" label="本地支付编号" width="200" align="center"></el-table-column>
                <el-table-column prop="payment_no" label="外部支付编号" width="200" align="center"></el-table-column>
                <el-table-column prop="total_amount" label="总金额" width="120" align="center"></el-table-column>
                <el-table-column prop="product_amount" label="商品金额" width="120" align="center"></el-table-column>
                <el-table-column prop="discount_amount" label="折扣金额" width="120" align="center"></el-table-column>
                <el-table-column prop="shipment_amount" label="邮费金额" width="120" align="center"></el-table-column>
                <el-table-column prop="is_paid" label="是否已取消" width="120" align="center">
                    <template slot-scope="scope" prop="is_cancel">
                        <el-tag type="info" v-if="scope.row.is_cancel === 0">未取消</el-tag>
                        <el-tag type="primary" v-else>已取消</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="支付状态" align="center">
                    <template slot-scope="scope">
                        <el-tag type="info" v-if="scope.row.is_paid === 0">未付款</el-tag>
                        <el-tag type="primary" v-if="scope.row.is_paid === 2">已付款</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="创建时间" width="150" align="center"></el-table-column>
                <el-table-column prop="created_at" label="更新时间" width="150" align="center"></el-table-column>
<!--                <el-table-column prop="remark" label="订单备注" width="150" align="center"></el-table-column>-->
                <el-table-column label="操作" align="center" width="150" fixed="right">
                    <template slot-scope="scope">
                            <el-button type="text" v-if="scope.row.is_paid === 0" @click="confirm(scope.$index, scope.row)">确认支付</el-button>
                            <el-button type="text" v-if="scope.row.is_paid === 2 && scope.row.is_cancel===0" @click="cancel(scope.$index, scope.row)">取消订单</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination v-bind:pageInfo="pageInfo" v-on:refreshPageSize="refreshPageSize" v-on:refreshPageNum="refreshPageNum" />
        </div>
        <!-- 新增 编辑 -->
        <el-dialog :title="title" :visible.sync="addVisible" width="600px" v-if="addVisible" class="dialog_box">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules" label-position="left">
                <el-form-item label="备注 " prop="remark">
                    <el-input v-model="form.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveData">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import Pagination from '@/components/Pagination';
import Url from '@/components/Url';
import loadEvents from '@/utils/loading'
import {request} from '@/common/request';
import {deal} from '@/common/main';
import {mapMutations} from 'vuex';

let loads = new loadEvents();
export default {
    components: {
        Breadcrumb,
        Pagination,
        Url
    },
    data() {
        return {
            tabPosition: 'all',
            choseState: null,
            title: '新增用户',
            addVisible: false,
            pageInfo: {},
            menuList: ['订单', '订单管理'],
            form: {
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            rules: {
                uid: [{
                    required: true,
                    message: '备注不能为空',
                    trigger: 'blur'
                }],
            },
        }
    },

    computed: {
        queryParams: {
            set: function (newValue) {
                this.$store.commit('initQueryParams', newValue)
            },
            get: function (newValue) {
                return this.$store.state.queryParams
            },
        }
    },
    beforeRouteEnter(to, from, next) {
        console.log('dddddd', to)
        console.log('dddddd', from)
        if (from.path === '/order-orderDetails') {
            next()
        } else {
            next(vm => {
                vm.queryParams = { page: 1, pagesize: 10 }
            })
        }

    },
    created() {
        if (this.queryParams.state) {
            if (this.queryParams.state === 1) {
                this.tabPosition = 8
            }
            if (this.queryParams.state === 2) {
                this.tabPosition = 4
            }
            if (this.queryParams.state === 3) {
                this.tabPosition = 3
            }
            if (this.queryParams.state === 4) {
                this.tabPosition = 5
            }
            if (this.queryParams.state === 5) {
                this.tabPosition = 6
            }
            if (this.queryParams.state === 6) {
                this.tabPosition = 7
            }
        } else if (this.queryParams.pay_state) {
            if (this.queryParams.pay_state === 0) {
                this.tabPosition = 1
            }
            if (this.queryParams.pay_state === 2) {
                this.tabPosition = 2
            }
        } else {
            this.tabPosition = 'all'
        }
        this.loadData()
    },
    watch: {
        $route(from) {
            let ArticleEdit = from.fullPath.indexOf('/order-orderDetails')
            if (ArticleEdit !== -1) {
                this.loadData()
            }
        }
    },
    methods: {
        ...mapMutations({
            'initQueryParams': 'initQueryParams'
        }),
        // 导出
        exportFile() {
            if (this.queryParams.ctime && this.queryParams.etime) {
                let data = this.queryParams;
                data.stime = this.queryParams.ctime;
                data.etime = this.queryParams.etime

                request.get('/order/export', data).then(ret => {
                    if (ret.code === 1) {
                        this.$message.success('导出成功');
                    } else {
                        this.$message.error(ret.msg);
                    }
                });
            } else {
                this.$message.error('请选择时间');
            }
        },
        //编辑
        edit(index, row) {
            this.mode = 'edit';
            this.title = '编辑';
            this.addVisible = true;
            this.form.id = row.id
        },
        //商品列表
        loadData() {
            this.loading = true;
            let _this = this
            request.get('/order/aikucun/list', this.queryParams).then(ret => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.pageInfo = ret.data;
                    this.pageInfo.list = ret.data.list;
                    this.pageInfo.list.map(function (val) {
                        val.pay_time = deal.timestamp(val.paid_at, 'unix');
                        return val;
                    })
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        //增加编辑
        saveData() {
            if (this.$refs.form) {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        var url = '/order/remark/edit';
                        //处理时间
                        request.post(url, this.form).then(ret => {
                            if (ret.code == 1) {
                                this.addVisible = false;
                                this.loadData();
                                this.$message.success((this.mode == 'add' ? '新增' : '编辑') +
                                    '成功');
                                this.$refs.form.clearValidate()
                            } else {
                                this.$message.error(ret.msg);
                            }
                        });
                    } else {
                        this.$message.error('请补全信息');
                        return false;
                    }
                });
            };
        },
        changeQuery() {
            this.queryParams.page = 1;
            if (this.queryParams.time) {
                let arr = Object.assign({}, this.queryParams.time)
                this.queryParams.ctime = deal.timestamp(arr[0]);
                this.queryParams.etime = deal.timestamp(arr[1]);
            } else {
                delete this.queryParams.ctime
                delete this.queryParams.etime
            }
            this.loadData();
        },
        refreshPageSize(val) {
            this.queryParams.pagesize = val;
            if (this.queryParams.time) {
                let arr = Object.assign({}, this.queryParams.time)
                this.queryParams.ctime = deal.timestamp(arr[0]);
                this.queryParams.etime = deal.timestamp(arr[1]);
            } else {
                delete this.queryParams.ctime
                delete this.queryParams.etime
            }
            this.loadData()
        },
        refreshPageNum(val) {
            this.queryParams.page = val;
            if (this.queryParams.time) {
                let arr = Object.assign({}, this.queryParams.time)
                this.queryParams.ctime = deal.timestamp(arr[0]);
                this.queryParams.etime = deal.timestamp(arr[1]);
            } else {
                delete this.queryParams.ctime
                delete this.queryParams.etime
            }
            this.loadData()
        },
        changState() {
            this.queryParams.page = 1
            this.queryParams.pagesize = 10
            switch (this.tabPosition) {
                case 'all':
                    delete this.queryParams.pay_state
                    delete this.queryParams.state
                    break;
                case '1':
                    delete this.queryParams.state
                    this.queryParams.pay_state = 0
                    break;
                case '2':
                    delete this.queryParams.state
                    this.queryParams.pay_state = 2
                    this.queryParams.state = 1
                    break;
                case '3':
                    delete this.queryParams.pay_state
                    this.queryParams.state = 3
                    break;
                case '4':
                    delete this.queryParams.pay_state
                    this.queryParams.state = 2
                    break;
                case '5':
                    delete this.queryParams.pay_state
                    this.queryParams.state = 4
                    break;
                case '6':
                    delete this.queryParams.pay_state
                    this.queryParams.state = 5
                    break;
                case '7':
                    delete this.queryParams.pay_state
                    this.queryParams.state = 6
                    break;
                case '8':
                    delete this.queryParams.pay_state
                    this.queryParams.state = 1
                    break;

            }
            this.loadData()
        },
        //查看详情
        confirm(index, row) {
            let data ={"ordersn":row.local_order_no}
            request.get('/order/aikucun/paidconfirm', data).then(ret => {
                if (ret.code === 1) {
                    this.$message.success('确认支付成功');
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        //查看详情
        cancel(index, row) {
            let data ={"ordersn":row.local_order_no}
            request.get('/order/aikucun/cancel', data).then(ret => {
                if (ret.code === 1) {
                    this.$message.success('确认取消成功');
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        //发货
        goDeliver() {
            this.$router.push('deliver')
        },
        beforeAvatarUpload(file) {
            let fileName = file.name
            let pos = fileName.lastIndexOf('.')
            let lastName = fileName.substring(pos, fileName.length)
            if (lastName.toLowerCase() !== '.xlsx') {
                this.$message.error('不支持此文件格式!');
            }
            loads.open(`body`, '导入中');
        },
        handleAvatarSuccess(res, file) {
            loads.close();
            if (res.code == 1) {
                this.loadData();
            } else {
                this.$message.error(res.msg);
            }
        }
    }
};
</script>

<style  scoped>
.red {
    color: #ff0000;
}

.green {
    color: green;
}

/* 对话框样式 */

.dialog_box >>> .el-dialog__body {
    padding: 20px 30px 20px 60px;
}

.dialog_box >>> .el-dialog__header {
    padding: 30px 30px 10px;
}

.dialog_box .el-form-item--small.el-form-item {
    margin-bottom: 20px;
}
</style>
